import React, { useEffect, useId } from "react";
import { IconX } from "@tabler/icons-react";

const Modal = ({ title, onClose, children, footer, width }) => {
  const titleId = useId();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = overflow;
    };
  }, [onClose]);

  return (
    <div className="modal">
      <button className="modal__backdrop" type="button" aria-label="Close dialog" onClick={onClose} />
      <div
        className="modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        style={width ? { maxWidth: width } : undefined}
      >
        <div className="modal__header">
          <h2 className="modal__title" id={titleId}>
            {title}
          </h2>
          <button className="btn btn--ghost btn--icon" type="button" aria-label="Close" onClick={onClose}>
            <IconX size={20} stroke={1.75} />
          </button>
        </div>
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
